
import { useState } from 'react';

interface Category {
  id: string;
  name: string;
}

interface ArticleTabsProps {
  categories: Category[];
  activeCategory: string | null;
  onCategoryChange: (categoryId: string | null) => void;
}

export default function ArticleTabs({ categories, activeCategory, onCategoryChange }: ArticleTabsProps) {
  return (
    <div className="mb-8">
      <div className="flex flex-wrap gap-2 md:gap-4">
        <button
          onClick={() => onCategoryChange(null)}
          className={`px-4 py-2 text-sm rounded-full transition-all ${
            activeCategory === null
              ? 'bg-white/10 text-white font-medium'
              : 'text-gray-400 hover:text-white'
          }`}
        >
          All posts
        </button>
        
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`px-4 py-2 text-sm rounded-full transition-all ${
              activeCategory === category.id
                ? 'bg-white/10 text-white font-medium'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            {category.name}
          </button>
        ))}
      </div>
    </div>
  );
}
